import api from '../api'

const baseUrl = '/academy/api/AdminStudent'

const skillUpStudentProvider = {
  getStudent(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },

  // type: Package - Course - Home - Career
  addStudent(params, type) {
    return api.post(`${baseUrl}/Add${type}`, params)
  },

  updateStudent(params = {}) {
    return api.put(`${baseUrl}/Edit`, params)
  },

  deleteStudent(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },
}

export default skillUpStudentProvider
